module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current && _vm.slides) ? _c('div', {
    staticClass: "current"
  }, [_c('div', {
    ref: "viewer",
    attrs: {
      "id": "viewer2"
    },
    on: {
      "click": _vm.viewerClick
    }
  }, [_c('current-project', {
    attrs: {
      "title": "Current",
      "current": _vm.currentSlide,
      "slides": _vm.slides,
      "transition": _vm.transition
    },
    on: {
      "imgHover": function($event) {
        _vm.showTitle(_vm.slides[_vm.currentSlide].caption, true)
      },
      "imgLeave": _vm.hideTitle
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1586ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Current.vue
// module id = 155
// module chunks = 1